import React from "react";
import { Card, CardContent } from "../ui/card";

export default function DashboardKpiCard({ label, helper, value, secondary, icon: Icon, accent, testid }) {
  return (
    <Card className="min-w-0 overflow-hidden rounded-lg" data-testid={testid}>
      <CardContent className="flex items-start justify-between gap-3 p-4 sm:p-5">
        <div className="min-w-0">
          <p className="break-words text-xs font-semibold uppercase tracking-[0.12em] text-muted-foreground">
            {label}
          </p>
          {helper ? <p className="mt-1 text-xs text-muted-foreground">{helper}</p> : null}
          <p className="mt-2 text-3xl font-semibold tabular-nums text-foreground">{value}</p>
          {secondary ? <p className="mt-1 text-xs font-medium text-muted-foreground">{secondary}</p> : null}
        </div>
        <span
          className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border ${accent}`}
          aria-hidden="true"
        >
          <Icon className="h-5 w-5" />
        </span>
      </CardContent>
    </Card>
  );
}
